import React from 'react';
import '../styles/Videos.css';

const Videos = () => {
    // TODO: Pide los enlaces y textos exactos cuando quieras avanzar
    // Estructura mobile first
    return (
        <main className="videos-page">
            {/* Bloque 1: Introducción */}
            <section className="videos-intro">
                <h1 className="videos-title">Bideoak</h1>
                <h2 className="videos-subtitle">Alaiak-en soinua eta zuzeneko esperientzia</h2>
                <p className="videos-desc">Gure kontzertu eta ekitaldietako uneak</p>
            </section>

            {/* Bloque 2: Vídeo principal (hero video) */}
            <section className="videos-hero">
                <div className="hero-video-wrapper">
                    <iframe
                        className="hero-video"
                        src="https://www.youtube.com/embed/hQDjRrn4Azw"
                        title="Vídeo principal AlaiaK"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </section>

            {/* Bloque 3: Galería de vídeos secundarios */}
            <section className="videos-gallery">
                <h3 className="gallery-title">Beste une batzuk</h3>
                <div className="gallery-list">
                    <div className="gallery-card">
                        <div className="gallery-thumb-wrapper">
                            <iframe
                                className="gallery-thumb"
                                src="https://www.youtube.com/embed/P0fqSLrH1VY"
                                title="Lady Gaga"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <div className="gallery-info">
                            <span className="gallery-video-title">Lady Gaga</span>
                            <span className="gallery-video-meta">San Pedro 2023</span>
                        </div>
                    </div>
                    <div className="gallery-card">
                        <div className="gallery-thumb-wrapper">
                            <iframe
                                className="gallery-thumb"
                                src="https://www.youtube.com/embed/RkUqVSiCG7k"
                                title="Captain Crow"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <div className="gallery-info">
                            <span className="gallery-video-title">Captain Crow</span>
                            <span className="gallery-video-meta">San Pedro 2024</span>
                        </div>
                    </div>
                    <div className="gallery-card">
                        <div className="gallery-thumb-wrapper">
                            <iframe
                                className="gallery-thumb"
                                src="https://www.youtube.com/embed/PMSdOIawacQ"
                                title="Loretxoa"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <div className="gallery-info">
                            <span className="gallery-video-title">Loretxoa</span>
                            <span className="gallery-video-meta">Santa Zezilia 2025</span>
                        </div>
                    </div>
                    <div className="gallery-card">
                        <div className="gallery-thumb-wrapper">
                            <iframe
                                className="gallery-thumb"
                                src="https://www.youtube.com/embed/RQbqNsUxhzU"
                                title="Concerto Grosso, Palladio"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <div className="gallery-info">
                            <span className="gallery-video-title">Concerto Grosso, Palladio</span>
                            <span className="gallery-video-meta">Santa Zezilia 2023</span>
                        </div>
                    </div>
                    <div className="gallery-card">
                        <div className="gallery-thumb-wrapper">
                            <iframe
                                className="gallery-thumb"
                                src="https://www.youtube.com/embed/feu3U_LmGSI"
                                title="17:25"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <div className="gallery-info">
                            <span className="gallery-video-title">17:25</span>
                            <span className="gallery-video-meta">San Pedro 2024</span>
                        </div>
                    </div>
                    <div className="gallery-card">
                        <div className="gallery-thumb-wrapper">
                            <iframe
                                className="gallery-thumb"
                                src="https://www.youtube.com/embed/BGB7UXSb76I"
                                title="Euritan Dantzan"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <div className="gallery-info">
                            <span className="gallery-video-title">Euritan Dantzan</span>
                            <span className="gallery-video-meta">San Pedro 2023</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Bloque 4: Contexto humano (opcional) */}
            <section className="videos-context">
                {/* TODO: Puedes personalizar esta frase */}
                <p>Zuzeneko musika, kalean eta agertokian, herriarekin batera.</p>
            </section>

            {/* Bloque 5: CTA suave */}
            <section className="videos-cta">
                {/* TODO: Elige uno de estos cierres */}
                <a href="/events" className="cta-link">Ikusi gure hurrengo ekitaldiak</a>
                {/* <a href="/kontaktua" className="cta-link">Jarri gurekin harremanetan</a> */}
            </section>
        </main>
    );
};

export default Videos;